<template>
  <div>
    <h3>Business Information</h3>
    <Dropdown
      :inputField="inputs.industry"
      :options="industryOptions"
      inputName="Industry"
      inputType="string"
    />
    <Input
      :inputField="inputs.justification"
      inputName="Provide a brief description of what your business does."
      inputType="string"
    />
    <Input
      @enter="next"
      :inputField="inputs.website"
      inputName="Business Website or Social Media Page"
      inputType="string_empty"
      :icons="{ left: 'fa-globe' }"
    />
    <h3>Business Start Date</h3>
    <Dropdown
      :inputField="inputs.startMonth"
      :options="monthOptions"
      inputName="Month"
      inputType="string"
    />
    <Input
      @enter="next"
      :inputField="inputs.startYear"
      inputName="Year"
      inputType="year"
    />
    <Choices
      :inputField="inputs.products"
      inputName="Which of the following products are you interested in?"
      :options="[
        'Working Capital',
        'Equipment Financing',
        'Line of Credit',
        'Vehicle Financing',
        // 'Sale-Leaseback',
        // 'Factoring',
      ]"
    /><Choices
      :inputField="inputs.loanuse"
      inputName="What will your business be using the loan for?"
      :options="[
        'Inventory',
        'Second Location',
        'Payroll',
        'Equipment Purchase',
        'Supplies',
        'Loan Consolidation',
      ]"
    />
    <div class="buttons is-right">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button" @click="next"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import Dropdown from "@/components/shared/Dropdown";
import ApplyPage from "@/components/shared/ApplyPage";
import Choices from "@/components/shared/Choices";
export default {
  name: "BusinessInfo",
  components: {
    Input,
    Dropdown,
    Choices,
  },
  mixins: [ApplyPage],
  data() {
    return {
      obj: "business",
      inputs: {
        industry: Input.model(),
        website: Input.model(),
        startMonth: Input.model(),
        startMonthNumber: 1,
        startYear: Input.model(),
        products: Input.model(),
        justification: Input.model(),
        loanuse: Input.model(),
      },
      monthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      industryOptions: [
        "Accounting",
        "Agriculture",
        "Alarm Company",
        "Automobile",
        "Auto Repair",
        "Automobile Sales",
        "Business Services",
        "Car Service/Limousine",
        "Chiropractic Treatment",
        "Clothing Store",
        "Computer/Electronics",
        "Consumer Services",
        "Construction",
        "Daycare",
        "Delivery service/Local",
        "Dry cleaners",
        "E-Commerce",
        "Education",
        "Electrician/Electrical Work",
        "Energy",
        "Excavating",
        "Facility Maintenance/Cleaning",
        "Financial Services",
        "Flooring",
        "Food Service",
        "Funeral Home/Cremation Services",
        "Government",
        "Grocery Store",
        "Gym",
        "Handyman/Repair",
        "HVAC",
        "Health/Pharmaceuticals",
        "Health/Fitness/Spa",
        "Home Care/Treatment Facility",
        "Hospitality",
        "IT Services",
        "Landscaping",
        "Lawyer/Attorney",
        "Liquor Store",
        "Manufacturing",
        "Marketing Firm/Public Relations",
        "Mining",
        "Media/Entertainment",
        "Medical/Dental",
        "Moving Company",
        "Non-Profit",
        "Oil And Gas",
        "Painter",
        "Pest Control",
        "Pet Care",
        "Plumbing/Heating",
        "Pool Design/Driveway/Paving",
        "Property Management",
        "Real Estate",
        "Restaurant",
        "Retail",
        "Roofing",
        "Staffing/HR Services",
        "Security Service",
        "Software/Internet",
        "Spa/Salon",
        "Storage/Containers",
        "Telecommunications",
        "Towing",
        "Transportation",
        "Travel/Leisure",
        "Utilities",
        "Vape Shop/Tobacco Shop",
        "Wholesale/Distribution",
        "Welding",
        "Wildlife Preservation/Fire Safety",
        "Window/Garage/Paving Installation",
        "Window Cleaning /Pressure Washing",
        "Other",
      ],
    };
  },
  mounted: function () {
    console.log("triggering contact form");
    this.$gtm.trackEvent({
      event: "contact_form",
      // category: 'Contact Form',
      // action: 'click',
      // label: 'Contact Form Complete',
      // value: 5000
    });
  },
  watch: {
    inputs: {
      deep: true,
      handler(newValue, oldvalue) {
        if (newValue.startMonth.value != "") {
          // console.log(newValue.startMonth.value);
          this.inputs.startMonthNumber =
            this.monthOptions.indexOf(newValue.startMonth.value) + 1;
          // console.log(this.inputs.startMonthNumber);
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
